import { DefaultLoader, LoaderContainer } from 'components/Loader';
import { FC, useContext, useMemo } from 'react';
import styled from 'styled-components';
import { MentoringContext } from '..';
import Accepted from './Accepted';
import Finished from './Finished';
import Interrupted from './Interrupted';
import InterruptionRequest from './InterruptionRequest';
import MenteeLate from './MenteeLate';
import MenteeLateFirstInterview from './MenteeLateFirstInterview';
import MenteeRefused from './MenteeRefused';
import MentorAccepting from './MentorAccepting';
import MentorLate from './MentorLate';
import MentorLateFirstInterview from './MentorLateFirstInterview';
import MentorRefused from './MentorRefused';
import Ongoing from './Ongoing';
import Waiting from './Waiting';

export const InputContainer = styled.div`
  max-width: 35rem;
  margin-bottom: 0.75rem;
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.9rem;
    margin-bottom: 0.375rem;
    color: var(--gray-700);
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 0.75rem;

  & > * {
    margin-right: 0.75rem;
  }
`;

const OngoingMentorship: FC = () => {
  const { mentorship } = useContext(MentoringContext);

  const View = useMemo(() => {
    switch (mentorship?.status) {
      case 'MENTOR_ACCEPTING':
        return MentorAccepting;
      case 'WAITING_MENTOR':
      case 'WAITING_MENTEE':
        return Waiting;
      case 'REFUSED_MENTEE':
        return MenteeRefused;
      case 'REFUSED_MENTOR':
        return MentorRefused;
      case 'FIRST_INTERVIEW':
        return Accepted;
      case 'LATE_MENTEE_FIRST_INTERVIEW':
        return MenteeLateFirstInterview;
      case 'LATE_MENTOR_FIRST_INTERVIEW':
        return MentorLateFirstInterview;
      case 'INTERRUPTION_REQUEST_MENTEE':
      case 'INTERRUPTION_REQUEST_MENTOR':
        return InterruptionRequest;
      case 'INTERRUPTED_ADMIN':
        return Interrupted;
      case 'FINISHED_ADMIN':
      case 'FINISHED_DATE':
        return Finished;
      case 'LATE_MENTEE':
        return MenteeLate;
      case 'LATE_MENTOR':
        return MentorLate;
      case 'ONGOING':
        return Ongoing;
      default:
        return () => (
          <LoaderContainer>
            <DefaultLoader />
          </LoaderContainer>
        );
    }
  }, [mentorship]);

  return <View />;
};

export default OngoingMentorship;
